import { motion } from "framer-motion";
import {
  FaPercentage,
  FaBolt,
  FaCoins,
  FaFileSignature,
  FaCheckCircle,
  FaEye,
  FaCalendarAlt,
  FaSmile,
} from "react-icons/fa";
import "./Features.css";

const features = [
  { icon: FaPercentage, title: "Lowest Interest Rates", desc: "Competitive rates that keep your borrowing cost down." },
  { icon: FaBolt, title: "Quick Gold Loan", desc: "Walk in with gold, walk out with cash — same day." },
  { icon: FaCoins, title: "Maximum Loan Value", desc: "Get the highest possible value against your gold." },
  { icon: FaFileSignature, title: "Easy Documentation", desc: "Minimal paperwork, straightforward process." },
  { icon: FaCheckCircle, title: "Instant Approval", desc: "Fast evaluation means faster approval." },
  { icon: FaEye, title: "Transparent Service", desc: "No hidden charges, no fine-print surprises." },
  { icon: FaCalendarAlt, title: "Flexible Repayment", desc: "Repayment plans that fit your schedule." },
  { icon: FaSmile, title: "Customer Friendly", desc: "Guided support at every step of your loan journey." },
];

const Features = () => {
  return (
    <section className="section lf-features">
      <div className="container">
        <div className="section-head-center">
          <span className="eyebrow">Loan Highlights</span>
          <h2 className="section-heading">
            Why Our <span className="accent-text">Loans</span> Work Better
          </h2>
          <p className="section-subtext">
            Every LENT FINANCE loan is built around speed, clarity, and fairness.
          </p>
        </div>

        <div className="lf-features__grid">
          {features.map(({ icon: Icon, title, desc }, i) => (
            <motion.div
              key={title}
              className="lf-features__card"
              initial={{ opacity: 0, y: 26 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.55, delay: (i % 4) * 0.1 }}
              whileHover={{ y: -6 }}
            >
              <span className="lf-features__icon">
                <Icon />
              </span>
              <h4>{title}</h4>
              <p>{desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;
